export const lngList = {
    fr: "Français",
    en: "English",
    sv: "Svenska",
    pt: "Português"
};
